import { Typo } from "@pepperstone/pepper-ui-kit";

export const HeaderTypo = ({
  text,
  alignEnd = false,
}: {
  text?: string;
  alignEnd?: boolean;
}) => (
  <Typo
    elem="p"
    size="sm"
    type="body"
    responsiveClasses={alignEnd ? "text-end" : ""}
  >
    {text}
  </Typo>
);
